export default "__VITE_ASSET__110e8a0a__"